export const formatDate = (rawDate: Date | string) => {
	const date: Date = (rawDate instanceof Date) ? rawDate : new Date(rawDate)
	const year = date.getFullYear()
	const month = ("0" + (date.getMonth() + 1)).slice(-2)
	const day = ("0" + (date.getDate() + 1)).slice(-2)

	return `${day}/${month}/${year}`
}
